import { Component, Input, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormArray, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { PackagesRules } from '../../services/packages-rules.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { PricingRulesService } from '../../services/pricing-rules.service';
import {UserService} from '../../services/user.service';
import {RuleDialog} from './rule-dialog/rule-dialog.component';
import {DialogSharedComponent} from '../dialog-shared/dialog-shared.component';

@Component({
  selector: 'ms-price-rules',
  templateUrl: './price-rules.component.html',
  providers: [PricingRulesService]
})
export class PriceRulesComponent implements OnInit {
    customers: any;
    margins: any = [];
    campaigns: any = [];
    general: any = [];
    ruleObjectAll: any;
    ruleObject: any;
    carriers: any = [];
    activeCarrier: string;
    allProducts: any = {};
    activeProduct: string;
    products: any = [];
    pid: string;
    customer: string;
    rules: any;
    customerRules: any;
    activeCustomer: any;
    ruleActions: any;
    ruleTypes: any;
    condLogic: any;
    condCompare: any;
    condProp: any;
    condPropVal: any;
    pricingRuleFor: string;
    campain: any;

    constructor(private userService: UserService,
                private _fb: FormBuilder,
                public dialog: MatDialog,
                private pricingRulesService: PricingRulesService) {}

    initCarriers() {
      this.pricingRulesService.getTypesRules();
      this.pricingRulesService.conditions.subscribe(
        (conditions) => {
          if (conditions) {
            this.ruleActions = conditions.ruleActions;
            this.ruleTypes = conditions.ruleTypes;
            this.condLogic = conditions.condLogic;
            this.condCompare = conditions.condCompare;
            this.condProp = conditions.condProp;
            this.condPropVal = conditions.condPropVal;
            this.carriers = conditions.carriers;
            this.allProducts = conditions.allProducts;
          }
        });
    }

    ngOnInit() {
      this.initCarriers();
      this.getUsers();
    }

  getUsers() {
    const params = {page: 0, size: '500', filter: '', sort: '', order: ''};
    this.userService.getUsers(params).subscribe((customers) => {
      this.customers = customers.data;
    });
  }

    setService($event) {
        this.products = this.allProducts[$event.value];
        this.margins = [];
        this.campaigns = [];
        this.general = [];
    }
    setProduct(item) {
        this.pid = item['value'];
        this.activeCustomer = null;
        this.customer = null;
        this.pricingRulesService.getPricingRules(this.pid).subscribe((data) => {
            this.rules = data;
            this.margins = data.margin;
            this.campaigns = data.campaign;
            this.general = data.general;
        }, (err) => {
            console.log(err);
        });
    }
    setCustomer(item) {
        this.activeProduct = null;
        this.activeCarrier = null;
        this.pid = null;
        this.customer = item['value'];
        this.pricingRulesService.getCustomerRules(this.customer).subscribe((data) => {
            this.rules = data;
            this.customerRules = data.customer;
        }, (err) => {
            console.log(err);
        });
    }

    getCampainRules({value}) {
      if (value === 'all' && !this.campain) {
        this.pricingRulesService.getCampainRules().subscribe(data => this.campain = data);
      }
    }

    addMargin(pid: string) {
        this.openRuleDialog('margin', pid);
    }
    addCampaign(pid: string) {
        this.openRuleDialog('campaign', pid);
    }
    addGeneral(pid: string) {
        this.openRuleDialog('general', pid);
    }

    transferDataSuccess(arr: any, item: any, pos: any) {
        this.changeOrder(arr);
    }

    changeOrder(items: any) {
        const sort = {
            'objects': []
        };
        for (const i in items) {
            items[i]['order'] = i;
            sort['objects'].push({
                'id': items[i]['id'],
                'order': items[i]['order']
            });
        }
        this.pricingRulesService.sortPricingRules(sort).subscribe((data) => {
        }, (err) => {
            console.log(err);
        });
    }

    openRuleDialog(type: string, pid: string, item: any = '') {
        const dialogRef = this.dialog.open(RuleDialog, {width: '600px'});
        dialogRef.afterClosed().subscribe(result => {
          let observable;
          if (this.pricingRuleFor === 'all') {
            observable = this.pricingRulesService.getCampainRules()
              .subscribe(data => this.campain = data);
          } else {
            observable = this.pid ?
              this.pricingRulesService.getPricingRules(this.pid) :
              this.pricingRulesService.getCustomerRules(this.customer);
            observable.subscribe((data) => {
              this.rules = data;
              if (data.margin) { this.margins = data.margin; } else { this.margins = []; }
              if (data.campaign) { this.campaigns = data.campaign; } else { this.campaigns = []; }
              if (data.general) { this.general = data.general; } else { this.general = []; }
              if (data.customer) { this.customerRules = data.customer; } else { this.customerRules = []; }
            }, (err) => {
              console.log(err);
            });
          }
        });

        const params = {
            type: type,
            pid: pid,
            item: item
        };
        const rules = {
            ruleActions: this.ruleActions,
            ruleTypes: this.ruleTypes
        };
        const cond = {
            condLogic: this.condLogic,
            condCompare: this.condCompare,
            condProp: this.condProp,
            condPropVal: {...this.condPropVal}
        };
        // allow product_id and carrier_id conditions only for customer
        if (!this.customer) {
          cond.condProp = cond.condProp.filter(({value}) => !['carrier_id', 'product_id'].includes(value));
          delete cond.condPropVal.carrier_id;
          delete cond.condPropVal.product_id;
        }
        dialogRef.componentInstance.rule = params;
        dialogRef.componentInstance.rules = rules;
        dialogRef.componentInstance.cond = cond;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/price-rules/price-rules.component.ts